import React, { Component } from "react";

import { Button, Container, Row, Form, Col, Offcanvas } from "react-bootstrap";

import { toast } from "react-toastify";

import DataTable from "react-data-table-component";

import configData from "../config.json";

import LoadingOverlay from "./LoadingOverlay";
export default class Leadopportunity extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      loadingMessage: "Processing your request...",
      show: false,

      data: [],

      sId: sessionStorage.getItem("sessionId"),

      uId: sessionStorage.getItem("uId"),

      errors: {},

      filteredData: null,

      tableClms: [
        {
          name: "S.NO",

          selector: (row, i) => row.leadopportunity_Id,

          sortable: true,

          cell: (row) => <span>{row.leadopportunity_Id}</span>,
        },

        {
          name: "Lead Id",
          selector: (row, i) => row.leadId,
          sortable: true,
          cell: (row) => <span>{row.leadId}</span>,
        },
        {
          name: "Lead Name",
          selector: (row, i) => row.leadName,
          sortable: true,
          cell: (row) => <span>{row.leadName}</span>,
        },
        {
          name: "Product Type",
          selector: (row, i) => row.productType,
          sortable: true,
          cell: (row) => <span>{row.productType}</span>,
        },
        {
          name: "Leadclosure Date",
          selector: (row, i) => row.leadclosureDate,
          sortable: true,
          cell: (row) => <span>{row.leadclosureDate}</span>,
        },
        {
          name: "Expectedlead Value",
          selector: (row, i) => row.expectedleadValue,
          sortable: true,
          cell: (row) => <span>{row.expectedleadValue}</span>,
        },
        {
          name: "Leadstage Id",
          selector: (row, i) => row.leadstageId,
          sortable: true,
          cell: (row) => <span>{row.leadstageId}</span>,
        },
        {
          name: "Leadcontact ID",
          selector: (row, i) => row.leadcontactId,
          sortable: true,
          cell: (row) => <span>{row.leadcontactId}</span>,
        },
        {
          name: "Leadorganization ID",
          selector: (row, i) => row.leadorganizationId,
          sortable: true,
          cell: (row) => <span>{row.leadorganizationId}</span>,
        },
        {
          name: "Lead Owner",
          selector: (row, i) => row.leadOwner,
          sortable: true,
          cell: (row) => <span>{row.leadOwner}</span>,
        },
        {
          name: "Lead Status",
          selector: (row, i) => row.leadStatus,
          sortable: true,
          cell: (row) => <span>{row.leadStatus}</span>,
        },
        {
          name: "Annualrenewal Date",
          selector: (row, i) => row.annualrenewalDate,
          sortable: true,
          cell: (row) => <span>{row.annualrenewalDate}</span>,
        },
        {
          name: "Dummy One",
          selector: (row, i) => row.dummyOne,
          sortable: true,
          cell: (row) => <span>{row.dummyOne}</span>,
        },
        {
          name: "Dummy Two",
          selector: (row, i) => row.dummyTwo,
          sortable: true,
          cell: (row) => <span>{row.dummyTwo}</span>,
        },
        {
          name: "Dummy Three",
          selector: (row, i) => row.dummyThree,
          sortable: true,
          cell: (row) => <span>{row.dummyThree}</span>,
        },
        {
          name: "Dummy Four",
          selector: (row, i) => row.dummyFour,
          sortable: true,
          cell: (row) => <span>{row.dummyFour}</span>,
        },
        {
          name: "Dummy Five",
          selector: (row, i) => row.dummyFive,
          sortable: true,
          cell: (row) => <span>{row.dummyFive}</span>,
        },

        {
          name: "Pipeline Id",
          selector: (row, i) => row.pipelineId,
          sortable: true,
          cell: (row) => <span>{row.pipelineId}</span>,
        }, //***tableClms

        {
          name: "Actions",

          sortable: false,

          cell: (row) => (
            <div>
              {/* edit button and delete button */}

              <Button
                style={{ marginRight: "10px" }}
                variant="primary"
                onClick={() => this.LeadopportunityeditHandler(row)}
                className="bi bi-pen"
              ></Button>

              <Button
                variant="danger"
                onClick={() => this.handleDelete(row)}
                className="bi bi-trash danger"
              ></Button>
            </div>
          ),
        },
      ],

      currentPage: 1,

      itemsPerPage: 10,

      isEditing: false,

      leadopportunity_Id: "",

      leadId: "",
      leadName: "",
      productType: "",
      leadclosureDate: "",
      expectedleadValue: "",
      leadstageId: "",
      leadcontactId: "",
      leadorganizationId: "",
      leadOwner: "",
      leadStatus: "",
      annualrenewalDate: "",
      dummyOne: "",
      dummyTwo: "",
      dummyThree: "",
      dummyFour: "",
      dummyFive: "",

      pipelineId: "", //***state
    };
  }

  // offcanvas Open

  handleOffcanvasShow = () => {
    this.setState({
      show: true,
      leadId: "",
      leadName: "",
      productType: "",
      leadclosureDate: "",
      expectedleadValue: "",
      leadstageId: "",
      leadcontactId: "",
      leadorganizationId: "",
      leadOwner: "",
      leadStatus: "",
      annualrenewalDate: "",
      dummyOne: "",
      dummyTwo: "",
      dummyThree: "",
      dummyFour: "",
      dummyFive: "",
    });
  };

  // Offcanvas close button

  handleOffcanvasClose = () => {
    this.setState({
      show: false,
      isEditing: false,
      leadId: "",
      leadName: "",
      productType: "",
      leadclosureDate: "",
      expectedleadValue: "",
      leadstageId: "",
      leadcontactId: "",
      leadorganizationId: "",
      leadOwner: "",
      leadStatus: "",
      annualrenewalDate: "",
      dummyOne: "",
      dummyTwo: "",
      dummyThree: "",
      dummyFour: "",
      dummyFive: "",
    });
  };

  showToast = (msg, type) => {
    switch (type) {
      case "success":
        toast.success(msg);

        break;

      case "error":
        toast.error(msg);

        break;

      case "warning":
        toast.warn(msg); // 'warn' is used instead of 'warning'

        break;

      default:
        toast.info(msg);
    }
  };

  LeadopportunityeditHandler = (row) => {
    // e.preventDefault();

    this.setState({
      isEditing: true,
      leadopportunity_Id: row.leadopportunity_Id,
      leadId: row.leadId,
      leadName: row.leadName,
      productType: row.productType,
      leadclosureDate: row.leadclosureDate,
      expectedleadValue: row.expectedleadValue,
      leadstageId: row.leadstageId,
      leadcontactId: row.leadcontactId,
      leadorganizationId: row.leadorganizationId,
      leadOwner: row.leadOwner,
      leadStatus: row.leadStatus,
      annualrenewalDate: row.annualrenewalDate,
      dummyOne: row.dummyOne,
      dummyTwo: row.dummyTwo,
      dummyThree: row.dummyThree,
      dummyFour: row.dummyFour,
      dummyFive: row.dummyFive,
      pipelineId: row.pipelineId, //***editstate
    });
  };

  LeadopportunityfetchHandler = () => {
    var formData = new FormData();

    formData.append("sId", this.state.sId);

    formData.append("uId", this.state.uId);

    fetch(configData.api_url + "C_Leadopportunity/list", {
      // Enter your IP address here

      method: "POST",

      //headers :{ 'Content-Type' : 'application/json'},

      mode: "cors",

      body: formData, // body data type must match "Content-Type" header
    })
      .then((response) => response.json())

      .then((data) => {
        if (data.status === "success") {
          this.setState({ data: data.list });
        }
      });
  };

  LeadopportunitysubmitHandler = (e) => {
    e.preventDefault();

    //   setButtons(contacts);

    var formData = new FormData();

    formData.append("sId", this.state.sId);

    formData.append("uId", this.state.uId);

    formData.append("leadId", this.state.leadId);

    formData.append("leadName", this.state.leadName);

    formData.append("productType", this.state.productType);

    formData.append("leadclosureDate", this.state.leadclosureDate);

    formData.append("expectedleadValue", this.state.expectedleadValue);

    formData.append("leadstageId", this.state.leadstageId);

    formData.append("leadcontactId", this.state.leadcontactId);

    formData.append("leadorganizationId", this.state.leadorganizationId);

    formData.append("leadOwner", this.state.leadOwner);

    formData.append("leadStatus", this.state.leadStatus);

    formData.append("annualrenewalDate", this.state.annualrenewalDate);

    formData.append("dummyOne", this.state.dummyOne);

    formData.append("dummyTwo", this.state.dummyTwo);

    formData.append("dummyThree", this.state.dummyThree);

    formData.append("dummyFour", this.state.dummyFour);

    formData.append("dummyFive", this.state.dummyFive);

    formData.append("pipelineId", this.state.pipelineId);
    //***tableData*

    this.setState({ loading: true, loadingMessage: "Saving..." });
    fetch(configData.api_url + "C_Leadopportunity/add", {
      // Enter your IP address here

      method: "POST",

      //headers :{ 'Content-Type' : 'application/json'},

      mode: "cors",

      body: formData, // body data type must match "Content-Type" header
    })
      .then((response) => response.json())

      .then((data) => {
        this.showToast(data.message, data.status);

        if (data.status === "success") {
          this.LeadopportunityfetchHandler();

          this.handleOffcanvasClose();

          this.setState({
            leadId: "",
            leadName: "",
            productType: "",
            leadclosureDate: "",
            expectedleadValue: "",
            leadstageId: "",
            leadcontactId: "",
            leadorganizationId: "",
            leadOwner: "",
            leadStatus: "",
            annualrenewalDate: "",
            dummyOne: "",
            dummyTwo: "",
            dummyThree: "",
            dummyFour: "",
            dummyFive: "",
          });
        }
      
        this.setState({ loading: false });})
    .catch(() => { this.setState({ loading: false }); });
  };

  LeadopportunityupdateHandler = (e) => {
    e.preventDefault();

    var formData = new FormData();

    formData.append("sId", this.state.sId);

    formData.append("uId", this.state.uId);

    formData.append("leadopportunity_Id", this.state.leadopportunity_Id);

    formData.append("leadId", this.state.leadId);

    formData.append("leadName", this.state.leadName);

    formData.append("productType", this.state.productType);

    formData.append("leadclosureDate", this.state.leadclosureDate);

    formData.append("expectedleadValue", this.state.expectedleadValue);

    formData.append("leadstageId", this.state.leadstageId);

    formData.append("leadcontactId", this.state.leadcontactId);

    formData.append("leadorganizationId", this.state.leadorganizationId);

    formData.append("leadOwner", this.state.leadOwner);

    formData.append("leadStatus", this.state.leadStatus);

    formData.append("annualrenewalDate", this.state.annualrenewalDate);

    formData.append("dummyOne", this.state.dummyOne);

    formData.append("dummyTwo", this.state.dummyTwo);

    formData.append("dummyThree", this.state.dummyThree);

    formData.append("dummyFour", this.state.dummyFour);

    formData.append("dummyFive", this.state.dummyFive);

    formData.append("pipelineId", this.state.pipelineId);
    //***tableData1

    this.setState({ loading: true, loadingMessage: "Updating..." });
    fetch(configData.api_url + "C_Leadopportunity/update", {
      method: "POST",

      mode: "cors",

      body: formData,
    })
      .then((response) => response.json())

      .then((data) => {
        this.showToast(data.message, data.status);

        if (data.status === "success") {
          this.LeadopportunityfetchHandler();

          this.handleOffcanvasClose();
        }
      
        this.setState({ loading: false });})
    .catch(() => { this.setState({ loading: false }); });
  };

  componentDidMount() {
    this.LeadopportunityfetchHandler();

    //***componentDidMount
  }

  handleleadIdChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;

    this.setState({ leadId: fieldValue });
  };
  handleleadNameChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;

    this.setState({ leadName: fieldValue });
  };
  handleproductTypeChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;

    this.setState({ productType: fieldValue });
  };
  handleleadclosureDateChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;

    this.setState({ leadclosureDate: fieldValue });
  };
  handleexpectedleadValueChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;

    this.setState({ expectedleadValue: fieldValue });
  };
  handleleadstageIdChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;

    this.setState({ leadstageId: fieldValue });
  };
  handleleadcontactIdChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;

    this.setState({ leadcontactId: fieldValue });
  };
  handleleadorganizationIdChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;

    this.setState({ leadorganizationId: fieldValue });
  };
  handleleadOwnerChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;

    this.setState({ leadOwner: fieldValue });
  };
  handleleadStatusChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;

    this.setState({ leadStatus: fieldValue });
  };
  handleannualrenewalDateChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;

    this.setState({ annualrenewalDate: fieldValue });
  };
  handledummyOneChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;

    this.setState({ dummyOne: fieldValue });
  };
  handledummyTwoChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;

    this.setState({ dummyTwo: fieldValue });
  };
  handledummyThreeChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;

    this.setState({ dummyThree: fieldValue });
  };
  handledummyFourChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;

    this.setState({ dummyFour: fieldValue });
  };
  handledummyFiveChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;

    this.setState({ dummyFive: fieldValue });
  };

  handlepipelineIdChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ pipelineId: fieldValue });
  }; //***inputFunctions

  handleRowSelect = (row) => {
    this.setState({
      selectedRow: row.index,
    });
  };

  handleRowUpdate = (newData, oldData) => {
    const data = [...this.state.data];

    const index = oldData.index;

    data[index] = newData;

    this.setState({ data });
  };

  handleEdit = (row) => {
    console.log(`Editing row with ID ${row.id}`);

    // implement your edit logic here
  };

  handleDelete = (row, index) => {
    var formData = new FormData();

    formData.append("leadopportunity_Id", row.leadopportunity_Id);

    this.setState({ loading: true, loadingMessage: "Deleting..." });
    fetch(configData.api_url + "C_Leadopportunity/delete", {
      method: "POST",

      mode: "cors",

      body: formData,
    })
      .then((response) => response.json())

      .then((data) => {
        this.showToast(data.message, data.status);

        if (data.status === "success") {
          this.LeadopportunityfetchHandler();
        }
      
        this.setState({ loading: false });})
    .catch(() => { this.setState({ loading: false }); });
  };

  handlePageChange = (page) => {
    this.setState({ currentPage: page });
  };

  handlePerRowsChange = (newPerPage, page) => {
    this.setState({ itemsPerPage: newPerPage, currentPage: page });
  };

  handleFilter = (e) => {
    const searchValue = e.target.value.toLowerCase();

    const filteredData = this.state.data.filter((row) => {
      return Object.values(row).join(" ").toLowerCase().includes(searchValue);
    });

    this.setState({ filteredData });
  };

  render() {
    const paginatedData = this.state.filteredData
      ? this.state.filteredData.slice(
        (this.state.currentPage - 1) * this.state.itemsPerPage,

        this.state.currentPage * this.state.itemsPerPage
      )
      : this.state.data.slice(
        (this.state.currentPage - 1) * this.state.itemsPerPage,

        this.state.currentPage * this.state.itemsPerPage
      );

    return (
      <div className="page-title">
        <LoadingOverlay show={this.state.loading} message={this.state.loadingMessage} />
        <div className="row">
          <div className="col-md-12 col-sm-12 col-xs-12">
            <div className="x_panel">
              <div className="x_content">
                <div
                  id="datatable_wrapper"
                  className="dataTables_wrapper form-inline

                dt-bootstrap no-footer"
                >
                  <Row className="row">
                    <div>
                      <h3
                        className="logoskybluecolor"
                        style={{ textAlign: "start" }}
                      >
                        Lead oppurtunity
                      </h3>
                    </div>

                    <Col
                      className="d-flex justify-content-end"
                      style={{ marginRight: "5px", marginTop: "20px" }}
                    >
                      <Button
                        variant="primary"
                        style={{ float: "right", marginBottom: "10px" }}
                        className="bi bi-plus "
                        onClick={this.handleOffcanvasShow}
                      >
                        New
                      </Button>

                      <Offcanvas
                        show={this.state.show}
                        onHide={this.handleOffcanvasClose}
                        {...this.props}
                        style={{ width: "500px" }}
                        placement="end"
                        backdrop="true"
                      >
                        <Offcanvas.Header closeButton>
                          <Offcanvas.Title>Add Leadopportunity</Offcanvas.Title>
                        </Offcanvas.Header>

                        <Offcanvas.Body>
                          <Container
                            style={{ overflowY: "auto", height: "auto" }}
                          >
                            <Row className="divstyle">
                              <Row>
                                <Form>
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Lead Id
                                      </Form.Label>
                                    </Col>

                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={this.handleleadIdChange}
                                        className="form-control"
                                        name="leadId"
                                        value={this.state.leadId}
                                        required="required"
                                        placeholder="Enter Lead Id"
                                      />
                                    </Col>

                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.leadId}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Lead Name
                                      </Form.Label>
                                    </Col>

                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={this.handleleadNameChange}
                                        className="form-control"
                                        name="leadName"
                                        value={this.state.leadName}
                                        required="required"
                                        placeholder="Enter Lead Name"
                                      />
                                    </Col>

                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.leadName}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Product Type
                                      </Form.Label>
                                    </Col>

                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={this.handleproductTypeChange}
                                        className="form-control"
                                        name="productType"
                                        value={this.state.productType}
                                        required="required"
                                        placeholder="Enter Product Type"
                                      />
                                    </Col>

                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.productType}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Leadclosure Date
                                      </Form.Label>
                                    </Col>

                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="date"
                                        onChange={
                                          this.handleleadclosureDateChange
                                        }
                                        className="form-control"
                                        name="leadclosureDate"
                                        value={this.state.leadclosureDate}
                                        required="required"
                                        placeholder="Enter Leadclosure Date"
                                      />
                                    </Col>

                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.leadclosureDate}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Expectedlead Value
                                      </Form.Label>
                                    </Col>

                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={
                                          this.handleexpectedleadValueChange
                                        }
                                        className="form-control"
                                        name="expectedleadValue"
                                        value={this.state.expectedleadValue}
                                        required="required"
                                        placeholder="Enter Expectedlead Value"
                                      />
                                    </Col>

                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.expectedleadValue}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Leadstage Id
                                      </Form.Label>
                                    </Col>

                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={this.handleleadstageIdChange}
                                        className="form-control"
                                        name="leadstageId"
                                        value={this.state.leadstageId}
                                        required="required"
                                        placeholder="Enter Leadstage Id"
                                      />
                                    </Col>

                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.leadstageId}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Leadcontact ID
                                      </Form.Label>
                                    </Col>

                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={
                                          this.handleleadcontactIdChange
                                        }
                                        className="form-control"
                                        name="leadcontactId"
                                        value={this.state.leadcontactId}
                                        required="required"
                                        placeholder="Enter Leadcontact ID"
                                      />
                                    </Col>

                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.leadcontactId}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Leadorganization ID
                                      </Form.Label>
                                    </Col>

                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={
                                          this.handleleadorganizationIdChange
                                        }
                                        className="form-control"
                                        name="leadorganizationId"
                                        value={this.state.leadorganizationId}
                                        required="required"
                                        placeholder="Enter Leadorganization ID"
                                      />
                                    </Col>

                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {
                                        this.state.errors.leadorganizationId
                                      }{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Lead Owner
                                      </Form.Label>
                                    </Col>

                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={this.handleleadOwnerChange}
                                        className="form-control"
                                        name="leadOwner"
                                        value={this.state.leadOwner}
                                        required="required"
                                        placeholder="Enter Lead Owner"
                                      />
                                    </Col>

                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.leadOwner}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Lead Status
                                      </Form.Label>
                                    </Col>

                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={this.handleleadStatusChange}
                                        className="form-control"
                                        name="leadStatus"
                                        value={this.state.leadStatus}
                                        required="required"
                                        placeholder="Enter Lead Status"
                                      />
                                    </Col>

                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.leadStatus}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Annualrenewal Date
                                      </Form.Label>
                                    </Col>

                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="date"
                                        onChange={
                                          this.handleannualrenewalDateChange
                                        }
                                        className="form-control"
                                        name="annualrenewalDate"
                                        value={this.state.annualrenewalDate}
                                        required="required"
                                        placeholder="Enter Annualrenewal Date"
                                      />
                                    </Col>

                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.annualrenewalDate}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Dummy One
                                      </Form.Label>
                                    </Col>

                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={this.handledummyOneChange}
                                        className="form-control"
                                        name="dummyOne"
                                        value={this.state.dummyOne}
                                        required="required"
                                        placeholder="Enter Dummy One"
                                      />
                                    </Col>

                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.dummyOne}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Dummy Two
                                      </Form.Label>
                                    </Col>

                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={this.handledummyTwoChange}
                                        className="form-control"
                                        name="dummyTwo"
                                        value={this.state.dummyTwo}
                                        required="required"
                                        placeholder="Enter Dummy Two"
                                      />
                                    </Col>

                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.dummyTwo}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Dummy Three
                                      </Form.Label>
                                    </Col>

                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={this.handledummyThreeChange}
                                        className="form-control"
                                        name="dummyThree"
                                        value={this.state.dummyThree}
                                        required="required"
                                        placeholder="Enter Dummy Three"
                                      />
                                    </Col>

                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.dummyThree}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Dummy Four
                                      </Form.Label>
                                    </Col>

                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={this.handledummyFourChange}
                                        className="form-control"
                                        name="dummyFour"
                                        value={this.state.dummyFour}
                                        required="required"
                                        placeholder="Enter Dummy Four"
                                      />
                                    </Col>

                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.dummyFour}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Dummy Five
                                      </Form.Label>
                                    </Col>

                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={this.handledummyFiveChange}
                                        className="form-control"
                                        name="dummyFive"
                                        value={this.state.dummyFive}
                                        required="required"
                                        placeholder="Enter Dummy Five"
                                      />
                                    </Col>

                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.dummyFive}{" "}
                                    </div>
                                  </Row>
                                  <br />

                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Pipeline Id
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={this.handlepipelineIdChange}
                                        className="form-control"
                                        name="pipelineId"
                                        value={this.state.pipelineId}
                                        required="required"
                                        placeholder="Enter Pipeline Id"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.pipelineId}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  {/* tableContent */}
                                </Form>
                              </Row>
                            </Row>

                            <Row>
                              <Col
                                className="d-flex justify-content-end"
                                style={{ marginRight: "50px" }}
                              >
                                <Button
                                  className="button"
                                  variant="success"
                                  onClick={this.LeadopportunitysubmitHandler}
                                  style={{
                                    marginTop: "20px",
                                  }}
                                >
                                  Save
                                </Button>
                              </Col>
                            </Row>
                          </Container>
                        </Offcanvas.Body>
                      </Offcanvas>

                      {this.state.isEditing && (
                        // Edit Offcanvas

                        <Offcanvas
                          show={this.state.isEditing}
                          // onHide={() => this.setState({ isEditing: false })}

                          onHide={this.handleOffcanvasClose}
                          {...this.props}
                          style={{ width: "500px" }}
                          placement="end"
                          backdrop="true"
                        >
                          <Offcanvas.Header closeButton>
                            <Offcanvas.Title>
                              Edit Leadopportunity
                            </Offcanvas.Title>
                          </Offcanvas.Header>

                          <Offcanvas.Body>
                            <Container
                              style={{ overflowY: "auto", height: "auto" }}
                            >
                              <Row className="divstyle">
                                <Row>
                                  <Form>
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Lead Id
                                        </Form.Label>
                                      </Col>

                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={this.handleleadIdChange}
                                          className="form-control"
                                          name="leadId"
                                          value={this.state.leadId}
                                          required="required"
                                          placeholder="Enter Lead Id"
                                        />
                                      </Col>

                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.leadId}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Lead Name
                                        </Form.Label>
                                      </Col>

                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={this.handleleadNameChange}
                                          className="form-control"
                                          name="leadName"
                                          value={this.state.leadName}
                                          required="required"
                                          placeholder="Enter Lead Name"
                                        />
                                      </Col>

                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.leadName}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Product Type
                                        </Form.Label>
                                      </Col>

                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={
                                            this.handleproductTypeChange
                                          }
                                          className="form-control"
                                          name="productType"
                                          value={this.state.productType}
                                          required="required"
                                          placeholder="Enter Product Type"
                                        />
                                      </Col>

                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.productType}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Leadclosure Date
                                        </Form.Label>
                                      </Col>

                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="date"
                                          onChange={
                                            this.handleleadclosureDateChange
                                          }
                                          className="form-control"
                                          name="leadclosureDate"
                                          value={this.state.leadclosureDate}
                                          required="required"
                                          placeholder="Enter Leadclosure Date"
                                        />
                                      </Col>

                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.leadclosureDate}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Expectedlead Value
                                        </Form.Label>
                                      </Col>

                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={
                                            this.handleexpectedleadValueChange
                                          }
                                          className="form-control"
                                          name="expectedleadValue"
                                          value={this.state.expectedleadValue}
                                          required="required"
                                          placeholder="Enter Expectedlead Value"
                                        />
                                      </Col>

                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {
                                          this.state.errors.expectedleadValue
                                        }{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Leadstage Id
                                        </Form.Label>
                                      </Col>

                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={
                                            this.handleleadstageIdChange
                                          }
                                          className="form-control"
                                          name="leadstageId"
                                          value={this.state.leadstageId}
                                          required="required"
                                          placeholder="Enter Leadstage Id"
                                        />
                                      </Col>

                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.leadstageId}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Leadcontact ID
                                        </Form.Label>
                                      </Col>

                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={
                                            this.handleleadcontactIdChange
                                          }
                                          className="form-control"
                                          name="leadcontactId"
                                          value={this.state.leadcontactId}
                                          required="required"
                                          placeholder="Enter Leadcontact ID"
                                        />
                                      </Col>

                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.leadcontactId}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Leadorganization ID
                                        </Form.Label>
                                      </Col>

                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={
                                            this.handleleadorganizationIdChange
                                          }
                                          className="form-control"
                                          name="leadorganizationId"
                                          value={this.state.leadorganizationId}
                                          required="required"
                                          placeholder="Enter Leadorganization ID"
                                        />
                                      </Col>

                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {
                                          this.state.errors.leadorganizationId
                                        }{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Lead Owner
                                        </Form.Label>
                                      </Col>

                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={this.handleleadOwnerChange}
                                          className="form-control"
                                          name="leadOwner"
                                          value={this.state.leadOwner}
                                          required="required"
                                          placeholder="Enter Lead Owner"
                                        />
                                      </Col>

                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.leadOwner}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Lead Status
                                        </Form.Label>
                                      </Col>

                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={this.handleleadStatusChange}
                                          className="form-control"
                                          name="leadStatus"
                                          value={this.state.leadStatus}
                                          required="required"
                                          placeholder="Enter Lead Status"
                                        />
                                      </Col>

                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.leadStatus}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Annualrenewal Date
                                        </Form.Label>
                                      </Col>

                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="date"
                                          onChange={
                                            this.handleannualrenewalDateChange
                                          }
                                          className="form-control"
                                          name="annualrenewalDate"
                                          value={this.state.annualrenewalDate}
                                          required="required"
                                          placeholder="Enter Annualrenewal Date"
                                        />
                                      </Col>

                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {
                                          this.state.errors.annualrenewalDate
                                        }{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Dummy One
                                        </Form.Label>
                                      </Col>

                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={this.handledummyOneChange}
                                          className="form-control"
                                          name="dummyOne"
                                          value={this.state.dummyOne}
                                          required="required"
                                          placeholder="Enter Dummy One"
                                        />
                                      </Col>

                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.dummyOne}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Dummy Two
                                        </Form.Label>
                                      </Col>

                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={this.handledummyTwoChange}
                                          className="form-control"
                                          name="dummyTwo"
                                          value={this.state.dummyTwo}
                                          required="required"
                                          placeholder="Enter Dummy Two"
                                        />
                                      </Col>

                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.dummyTwo}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Dummy Three
                                        </Form.Label>
                                      </Col>

                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={this.handledummyThreeChange}
                                          className="form-control"
                                          name="dummyThree"
                                          value={this.state.dummyThree}
                                          required="required"
                                          placeholder="Enter Dummy Three"
                                        />
                                      </Col>

                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.dummyThree}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Dummy Four
                                        </Form.Label>
                                      </Col>

                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={this.handledummyFourChange}
                                          className="form-control"
                                          name="dummyFour"
                                          value={this.state.dummyFour}
                                          required="required"
                                          placeholder="Enter Dummy Four"
                                        />
                                      </Col>

                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.dummyFour}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Dummy Five
                                        </Form.Label>
                                      </Col>

                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={this.handledummyFiveChange}
                                          className="form-control"
                                          name="dummyFive"
                                          value={this.state.dummyFive}
                                          required="required"
                                          placeholder="Enter Dummy Five"
                                        />
                                      </Col>

                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.dummyFive}{" "}
                                      </div>
                                    </Row>
                                    <br />

                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Pipeline Id
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={this.handlepipelineIdChange}
                                          className="form-control"
                                          name="pipelineId"
                                          value={this.state.pipelineId}
                                          required="required"
                                          placeholder="Enter Pipeline Id"
                                        />
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.pipelineId}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    {/* tableContent */}
                                  </Form>
                                </Row>
                              </Row>

                              <Row>
                                <Col
                                  className="d-flex justify-content-end"
                                  style={{ marginRight: "50px" }}
                                >
                                  <Button
                                    className="button"
                                    variant="success"
                                    onClick={this.LeadopportunityupdateHandler}
                                    style={{
                                      marginTop: "20px",
                                    }}
                                  >
                                    Update
                                  </Button>
                                </Col>
                              </Row>
                            </Container>
                          </Offcanvas.Body>
                        </Offcanvas>
                      )}

                      {/*offcanvas is over */}
                    </Col>
                  </Row>

                  <br />

                  <Row>
                    <div style={{ marginRight: "5px" }}>
                      {/* searchbar,pagination,filter */}

                      <input
                        type="text"
                        style={{ float: "left", marginBottom: "10px" }}
                        onChange={this.handleFilter}
                        placeholder="Search..."
                      />

                      <DataTable
                        data={paginatedData}
                        columns={this.state.tableClms}
                        pagination
                        paginationServer
                        paginationTotalRows={
                          this.state.filteredData
                            ? this.state.filteredData.length
                            : this.state.data.length
                        }
                        onChangeRowsPerPage={this.handlePerRowsChange}
                        onChangePage={this.handlePageChange}
                        paginationRowsPerPageOptions={[100, 200, 300, 400, 500, 600, 700, 800, 900, 1000]}
                        paginationPerPage={100}
                        keyField="id"
                        className="table table-striped table-bordered dataTable no-footer employeesTableIcons"
                      />
                    </div>
                  </Row>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
